import * as tslib_1 from "tslib";
import { observable, action, computed } from 'mobx';
import AppEvent from 'src/models/AppEvent';
import UserApi from '../services/UserApi';
import DragDropPolicy from '../services/DragDropPolicy';
import store from '../store';
import { Claims } from '../models/User';
import { loading, Loadable } from '../utils/loading';
import UserMessages from './UserMessages';
var NOTIFICATION_DURATION = 4000;
var UserStore = /** @class */ (function (_super) {
    tslib_1.__extends(UserStore, _super);
    function UserStore() {
        var _this = _super.call(this) || this;
        _this.claims = [];
        _this.databases = [];
        _this.users = [];
        _this.sections = [];
        _this.employees = [];
        _this.verified = new AppEvent();
        _this.authorization = new AppEvent();
        _this.startNotify = new AppEvent();
        _this.endNotify = new AppEvent();
        _this.loadDatabases();
        return _this;
    }
    UserStore.prototype.login = function (userName, password, database) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserApi.login(userName, password, database)];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, this.setAuthenticationResult(result)];
                    case 2:
                        _a.sent();
                        if (!this.isAuthenticated) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.load()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, this.isAuthenticated];
                }
            });
        });
    };
    UserStore.prototype.verify = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserApi.verify()];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, this.setAuthenticationResult(result)];
                    case 2:
                        _a.sent();
                        if (!this.isAuthenticated) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.load()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.verified._fire(this.isAuthenticated);
                        return [2 /*return*/, this.isAuthenticated];
                }
            });
        });
    };
    UserStore.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, messages, _b, defaultSection;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, UserApi.getUsers(this.userId)];
                    case 1:
                        _a.users = _c.sent();
                        return [4 /*yield*/, UserApi.getMessages(this.userId)];
                    case 2:
                        messages = _c.sent();
                        _b = this;
                        return [4 /*yield*/, UserApi.getSections(this.userId)];
                    case 3:
                        _b.sections = _c.sent();
                        defaultSection = this.sections.find(function (s) { return s.default; });
                        if (defaultSection) {
                            this.selectedSection = defaultSection.sectionID;
                        }
                        this.messages = new UserMessages(this.userId, this.users, messages);
                        return [2 /*return*/];
                }
            });
        });
    };
    UserStore.prototype.loadDatabases = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, UserApi.getDatabases()];
                    case 1:
                        _a.databases = _b.sent();
                        this.database = this.databases[0];
                        return [2 /*return*/];
                }
            });
        });
    };
    UserStore.prototype.setDatabase = function (database) {
        this.database = database;
    };
    UserStore.prototype.logout = function () {
        this.userId = 0;
        this.userName = null;
        this.isAuthenticated = false;
        store.clear();
        UserApi.logout();
    };
    UserStore.prototype.notify = function (message) {
        var _this = this;
        this.notification = message;
        this.startNotify._fire(null);
        window.setTimeout(function () {
            _this.notification = null;
            _this.endNotify._fire(null);
        }, NOTIFICATION_DURATION);
    };
    UserStore.prototype.getUserById = function (userId) {
        return this.users.find(function (i) { return i.id === userId; });
    };
    UserStore.prototype.hasClaim = function (claim) {
        return this.claims && this.claims.indexOf(claim) !== -1;
    };
    UserStore.prototype.setAuthenticationResult = function (result) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                Object.assign(this, result);
                if (this.isAuthenticated) {
                    this.authorization._fire(this.isAuthenticated);
                    DragDropPolicy.setCurrent(this);
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(UserStore.prototype, "loggedInUserIsAdmin", {
        get: function () {
            return this.hasClaim(Claims.Admin) || this.hasClaim(Claims.Manager);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "userIdForLoading", {
        get: function () {
            return this.loggedInUserIsAdmin ? null : this.userId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "canCreateOtherTasks", {
        get: function () {
            return this.hasClaim(Claims.CreateOtherTask);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "environment", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "notification", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "isAuthenticated", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "userName", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "userId", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "claims", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "isBusy", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "database", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "databases", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "users", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "messages", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "sections", void 0);
    tslib_1.__decorate([
        observable
    ], UserStore.prototype, "selectedSection", void 0);
    tslib_1.__decorate([
        action.bound,
        loading
    ], UserStore.prototype, "login", null);
    tslib_1.__decorate([
        action.bound
    ], UserStore.prototype, "verify", null);
    tslib_1.__decorate([
        action.bound
    ], UserStore.prototype, "load", null);
    tslib_1.__decorate([
        action.bound
    ], UserStore.prototype, "loadDatabases", null);
    tslib_1.__decorate([
        action.bound
    ], UserStore.prototype, "setDatabase", null);
    tslib_1.__decorate([
        action.bound
    ], UserStore.prototype, "logout", null);
    tslib_1.__decorate([
        action.bound
    ], UserStore.prototype, "notify", null);
    tslib_1.__decorate([
        computed
    ], UserStore.prototype, "loggedInUserIsAdmin", null);
    tslib_1.__decorate([
        computed
    ], UserStore.prototype, "userIdForLoading", null);
    tslib_1.__decorate([
        computed
    ], UserStore.prototype, "canCreateOtherTasks", null);
    return UserStore;
}(Loadable));
export default UserStore;



//////////////////
// WEBPACK FOOTER
// ./src/store/UserStore.ts
// module id = 365
// module chunks = 0